import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { theme } from "./theme"
import { ThemeProvider } from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
        <App />
    </ThemeProvider>
  </React.StrictMode>
);
